import React, { ReactNode } from 'react';
import { useLanguageContext } from '@hooks/useLanguageContext';
import { useFetchAllPhysiciansQuery } from '@api/physicians/physiciansAPI';
import { useScheduleContext } from '@pages/Schedule/context/useScheduleContext';
import { getBlackourLocationForDate } from '@pages/Schedule/utils/getBlackoutsLocationForDate';
import { useFetchLocationBlackoutsQuery } from '@api/blackout/blackoutAPI';
import { skipToken } from '@reduxjs/toolkit/query';

export const DayHeader = () => {
  const { dictionary } = useLanguageContext();

  const { data: physicians } = useFetchAllPhysiciansQuery();

  const { selectedLocationId, selectedPhysician, selectedDate } = useScheduleContext();

  const { data: locationsBlackout } = useFetchLocationBlackoutsQuery(
    !selectedLocationId ? skipToken : selectedLocationId,
  );

  const blackoutLocationsSlots = getBlackourLocationForDate(selectedDate, locationsBlackout?.data);

  const isCurrentBlackoutLocations = blackoutLocationsSlots?.some(
    (slot) => slot.locationId === selectedLocationId,
  );

  const physiciansName = physicians?.data?.results
    .filter((physician) => physician?.schedule?.locationId === selectedLocationId)
    .map((physician) =>
      selectedPhysician?.length
        ? physician.id === selectedPhysician && physician.name
        : physician.name,
    );

  const hasPhysicians = Array.isArray(physiciansName) && physiciansName.length > 0;

  const includeBlackout = hasPhysicians && isCurrentBlackoutLocations;

  const tableSettings = [
    dictionary.schedule.table.time,
    ...(includeBlackout ? ['Blackout location'] : []),
    ...(hasPhysicians ? physiciansName : []),
  ];

  const tableHeader = tableSettings
    ?.reduce<ReactNode[] | any>(
      (acc, item, currentIndex) => [
        ...acc,
        <div
          className={`schedule-cell table-cell is-heading ${item === 'Blackout location' ? 'blackout-location' : ''}`}
          key={`schedule-cell-${currentIndex}`}
        >
          {item}
        </div>,
      ],
      [],
    )
    .map(
      (children: { props: { children: string } }) => children?.props.children.length && children,
    );

  return (
    <div className="schedule-header table-header">
      <div className="schedule-row table-row">{tableHeader}</div>
    </div>
  );
};
